import { useEffect, useState } from 'react';
import { useAppDispatch } from '@/store';
import { IProduct, IProductFilter } from '@/models/products.model';
import { getFiltersByCategory, getProductFiltersByCategory } from '@/modules/Products/feature';
import { useTranslation } from 'react-i18next';
import { showErrorToast } from '@/components';

export const useProductFilters = (product: IProduct | null) => {
  const { t } = useTranslation('products');
  const dispatch = useAppDispatch();
  const [filters, setFilters] = useState<IProductFilter[]>([]);

  const fetchFilters = async (value: string) => {
    if (product) {
      const filtersResponse = await dispatch(
        getProductFiltersByCategory({ productId: product.id, categoryId: value }),
      ).unwrap();
      setFilters(filtersResponse.data);
    } else {
      const filtersResponse = await dispatch(getFiltersByCategory(value)).unwrap();
      setFilters(filtersResponse.data);
    }
  };

  const handleCategoryChange = async (value: unknown) => {
    if (!value) {
      setFilters([]);
      return;
    }

    try {
      fetchFilters(value as string);
    } catch (error) {
      setFilters([]);
      showErrorToast(t('subcategory_load_error'));
    }
  };

  useEffect(() => {
    if (product?.category.id) {
      fetchFilters(product.category.id);
    }
  }, [product]);

  return { handleCategoryChange, filters };
};
